<template>
  <div>
    <b-modal
      id="BajaContratoModal"
      :hide-footer="true"
      size="xl"
      title="Baja de Contrato"
      @hidden="onHidden"
      @shown="onShown"
    >
      <form v-promise-btn="{ action: 'submit' }" @submit.prevent="validateForm">
        <card-item>
          <template>
            <div class="d-flex justify-content-center align-items-center">
              <h4 class="card-title">Baja de Contrato</h4>
            </div>
          </template>
          <div class="container">
            <div class="row">
              <template v-if="contrato">
                <div class="col-12 form-group form-group-sm">
                  <label class="label" for="idCliente"
                    >Nombre de cliente
                  </label>
                  <input
                    id="idCliente"
                    :class="`form-control form-control-sm text-center bg-white`"
                    v-model="nombreCliente"
                    disabled
                    style="cursor: text"
                    type="text"
                  />
                </div>
                <div class="col-12 col-md-6 form-group form-group-sm">
                  <label class="label" for="patente">Patente</label>
                  <input
                    id="patente"
                    :class="`form-control form-control-sm text-center bg-white`"
                    v-model="patente"
                    disabled
                    style="cursor: text"
                    type="text"
                  />
                </div>

                <div class="col-12 col-md-6 form-group form-group-sm">
                  <label class="label" for="alias">Alias</label>
                  <input
                    id="alias"
                    :class="`form-control form-control-sm text-center bg-white`"
                    v-model="alias"
                    disabled
                    style="cursor: text"
                    type="text"
                  />
                </div>
                <div class="col-12 col-md-6 form-group form-group-sm">
                  <label class="label" for="idAvlASacar">Id AVL</label>
                  <input
                    id="idAvlASacar"
                    :class="`form-control form-control-sm text-center bg-white`"
                    v-model="idAvlASacar"
                    disabled
                    style="cursor: text"
                    type="text"
                  />
                </div>
                <div class="col-12 col-md-6 form-group form-group-sm">
                  <label for="fecha_baja" class="label">Fecha de baja</label>
                  <input
                    v-model="fechaBaja"
                    type="datetime-local"
                    :class="`form-control form-control-sm text-center bg-white`"
                    id="fecha_baja"
                  />
                </div>
              </template>
              <template v-else>
                <div class="col-12">Cargando...</div>
              </template>
              <div class="col-12 col-md-6 form-group form-group-sm">
                <label class="label" for="comboIrrecuperable">
                  <input
                    id="comboIrrecuperable"
                    v-model="comboIrrecuperable"
                    class="form-check-inline"
                    type="checkbox"
                  />
                  Combo Irrecuperable
                </label>
              </div>
              <div
                v-show="comboIrrecuperable"
                :class="`col-12 col-md-6 form-group form-group-sm${
                  isDirty && !costoAVLOk ? ' is-invalid' : ''
                }`"
              >
                <label class="label" for="costoAVL">Costo AVL</label>
                <input
                  id="costoAVL"
                  v-select-on-focus
                  v-model="costoAVL"
                  :class="`form-control form-control-sm text-center bg-white${
                    isDirty && !costoAVLOk ? ' is-invalid' : ''
                  }`"
                  min="0"
                  style="cursor: text"
                  type="text"
                />
              </div>
              <div class="col-12 form-group form-group-sm mt-4 p-0">
                <FacturacionForm :disabled="true" />
              </div>
              <template v-if="!comboIrrecuperable">
                <div class="col-12 form-group form-group-sm">
                  <label class="label" for="instalador">Instalador</label>
                  <SelectInstalador
                    v-model="instalador"
                    :has-error="isDirty && !instaladorOk"
                  />
                </div>
                <div class="col-12 col-md-6 form-group form-group-sm">
                  <label class="label" for="entregadoEnMano">
                    <input
                      id="entregadoEnMano"
                      v-model="entregadoEnMano"
                      class="form-check-inline"
                      type="checkbox"
                    />
                    Entregado en mano
                  </label>
                </div>
                <div class="col-12 col-md-6 form-group form-group-sm">
                  <label class="label" for="taller">
                    <input
                      id="taller"
                      v-model="taller"
                      class="form-check-inline"
                      type="checkbox"
                    />
                    Taller
                  </label>
                </div>
                <div class="col-12 col-md-6 form-group form-group-sm">
                  <label class="label" for="relay">
                    <input
                      id="relay"
                      v-model="relay"
                      class="form-check-inline"
                      type="checkbox"
                    />
                    Relay
                  </label>
                </div>
                <div class="col-12 col-md-6 form-group form-group-sm">
                  <label class="label" for="precioXmayor">
                    <input
                      id="precioXmayor"
                      v-model="precioXmayor"
                      class="form-check-inline"
                      type="checkbox"
                    />
                    Precio por mayor
                  </label>
                </div>
              </template>
              <div class="col-12 form-group form-group-sm">
                <label class="label" for="devolucion_por_dias_sin_servicio">
                  <input
                    id="devolucion_por_dias_sin_servicio"
                    v-model="devolucion_por_dias_sin_servicio"
                    class="form-check-inline"
                    type="checkbox"
                  />
                  Devolución por dias sin servicio(prorrateo)
                </label>
              </div>
              <div class="col-12 form-group form-group-sm">
                <label class="label" for="comentarioTrazabilidad">
                  Comentario Trazabilidad
                </label>
                <textarea
                  id="comentarioTrazabilidad"
                  v-model="comentarioTrazabilidad"
                  class="form-control"
                  cols="30"
                  name="comentarioTrazabilidad"
                  rows="3"
                ></textarea>
              </div>
              <ViaticosForm v-model="viaticos" ref="viaticosForm" />
            </div>
            <div class="row">
              <div class="col-12">
                <div class="d-flex justify-content-between">
                  <button
                    class="btn btn-secondary"
                    type="button"
                    @click="cancelarModal"
                  >
                    Cancelar
                  </button>
                  <button class="btn btn-primary" type="submit">Aceptar</button>
                </div>
              </div>
            </div>
          </div>
        </card-item>
      </form>
    </b-modal>
    <b-modal
      id="CaptchaModal"
      size="md"
      title="¡Atención! Verificación Requerida"
      hide-footer
      centered
      no-close-on-backdrop
      no-close-on-esc
      header-bg-variant="warning"
      header-text-variant="dark"
      body-bg-variant="light"
      header-border-variant="warning"
    >
      <template>
        <div class="d-flex align-items-center w-100">
          <i class="fas fa-exclamation-triangle text-warning mr-2"></i>
          <h5 class="modal-title">¡Atención! Verificación Requerida</h5>
        </div>
      </template>

      <div class="captcha-container border-left border-warning pl-3">
        <p class="text-center mb-3 font-weight-bold text-dark">
          <i class="fas fa-shield-alt mr-1"></i>
          Para confirmar la baja del contrato con un AVL activo, por favor
          resuelva la siguiente operación:
        </p>

        <MathCaptcha v-model="isCaptchaValid" />

        <div class="alert alert-warning small mt-3">
          <i class="fas fa-info-circle"></i>
          Esta verificación es necesaria para operaciones sensibles que
          involucran dispositivos activos.
        </div>

        <div class="d-flex justify-content-between mt-4">
          <button class="btn btn-secondary" @click="cancelarCaptcha">
            <i class="fas fa-times mr-1"></i> Cancelar
          </button>
          <button
            class="btn btn-warning text-dark font-weight-bold"
            @click="submit"
          >
            <i class="fas fa-check mr-1"></i> Confirmar Baja
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import SelectInstalador from "@/pages/Clientes/Contratos/Commons/SelectInstalador";
import MathCaptcha from "../../shared/MathCaptcha.vue";
import ViaticosForm from "../../../../components/Viaticos/ViaticosForm.vue";
import FacturacionForm from "../Modificar/FacturacionForm.vue";
import axios from "axios";
import { get } from "lodash-es";
import moment from "../../../../../node_modules/moment/moment";

export default {
  name: "BajaContratoModal",
  components: {
    SelectInstalador,
    MathCaptcha,
    ViaticosForm,
    FacturacionForm,
  },
  data: () => ({
    isDirty: false,
    instalador: null,
    comboIrrecuperable: false,
    entregadoEnMano: false,
    idCliente: null,
    comentarioTrazabilidad: "",
    costoAVL: 0,
    taller: false,
    relay: false,
    precioXmayor: false,
    devolucion_por_dias_sin_servicio: false,
    isCaptchaValid: false,
    mostrarCaptcha: false,
    fechaBaja: null,
    viaticos: {
      viaticosCliente: {
        activo: false,
        combustible: {
          activo: false,
          kilometros: 0,
          montoCalculado: 0,
          desgloseCalculo: "",
          descripcion: "",
        },
        viaticoAdicional: { activo: false, monto: 0, descripcion: "" },
      },
      viaticosInstalador: {
        activo: false,
        combustible: {
          activo: false,
          kilometros: 0,
          montoCalculado: 0,
          desgloseCalculo: "",
          descripcion: "",
        },
        viaticoAdicional: { activo: false, monto: 0, descripcion: "" },
      },
    },
  }),
  methods: {
    async estadoAvl() {
      try {
        const resp = await axios.post("/execute", {
          method: "CLI.GetEstadoAVL",
          parameters: [{ name: "imei", value: this.imei }],
        });
        if (resp.data.ok) {
          if (resp.data.result[0][0].esta_reportando === 1) {
            try {
              const respuestaMensaje = await this.$bvModal.msgBoxConfirm(
                "Ojo! Éste AVL está reportando y conectado a bateria externa. ¿Está seguro que desea dar de baja el contrato?",
                {
                  title: "Advertencia",
                  size: "md",
                  buttonSize: "sm",
                  okVariant: "danger",
                  okTitle: "Sí, continuar",
                  cancelVariant: "secondary",
                  cancelTitle: "No, cancelar",
                  footerClass: "p-2",
                  hideHeaderClose: false,
                  centered: true,
                  headerBgVariant: "warning",
                  headerTextVariant: "dark",
                },
              );
              if (respuestaMensaje) {
                this.mostrarCaptcha = true;
                this.$bvModal.show("CaptchaModal");
              } else {
                this.mostrarCaptcha = false;
              }
            } catch (modalError) {
              this.mostrarCaptcha = false;
              this.$msgBoxOk("Error en la confirmación");
            }
          } else {
            this.submit();
          }
        } else {
          await this.$msgBoxOk(resp.data.message);
        }
      } catch (error) {
        this.$msgBoxOk(error);
        this.mostrarCaptcha = false;
      }
    },
    onHidden() {
      this.$store.commit("Contratos/BajaContrato/setContrato", null);
    },
    onShown() {
      this.isDirty = false;
      this.idCliente = this.$route.params.id_cliente;
      this.comboIrrecuperable = false;
      this.entregadoEnMano = false;
      this.comentarioTrazabilidad = "";
      this.costoAVL = 0;
      this.instalador = null;
      this.taller = false;
      this.relay = false;
      this.precioXmayor = false;
      this.devolucion_por_dias_sin_servicio = false;
      this.isCaptchaValid = false;
      this.fechaBaja = this.Fecha_baja;
      this.viaticos = {
        viaticosCliente: {
          activo: false,
          combustible: {
            activo: false,
            kilometros: 0,
            montoCalculado: 0,
            desgloseCalculo: "",
            descripcion: "",
          },
          viaticoAdicional: { activo: false, monto: 0, descripcion: "" },
        },
        viaticosInstalador: {
          activo: false,
          combustible: {
            activo: false,
            kilometros: 0,
            montoCalculado: 0,
            desgloseCalculo: "",
            descripcion: "",
          },
          viaticoAdicional: { activo: false, monto: 0, descripcion: "" },
        },
      };
    },
    cancelarCaptcha() {
      this.$bvModal.hide("CaptchaModal");
      this.isCaptchaValid = false;
    },

    cancelarModal() {
      this.$bvModal.hide("BajaContratoModal");
    },
    async validateForm() {
      this.isDirty = true;

      let mensaje = [];

      if (!this.isFormOk) {
        if (this.comboIrrecuperable) {
          if (
            this.costoAVL === null ||
            this.costoAVL === "" ||
            Number.isNaN(Number(this.costoAVL))
          ) {
            mensaje.push("Por favor, coloque un costo");
          }
        } else {
          if (!this.instalador) {
            mensaje.push("Por favor, seleccione un instalador");
          }
        }
      }

      if (this.$refs.viaticosForm) {
        const viaticosErrors = this.$refs.viaticosForm.validateForm();
        if (viaticosErrors.length > 0) {
          mensaje.push(...viaticosErrors);
        }
      }

      if (this.comentarioTrazabilidad.trim() === "") {
        mensaje.push("Por favor, complete el campo de trazabilidad");
      }

      if (this.imei === null || this.imei === undefined || this.imei === "") {
        mensaje.push("Ups, algo salio mal. IMEI no encontrado");
      }

      if (
        this.$route.params.id_contrato === null ||
        this.$route.params.id_contrato === undefined ||
        this.$route.params.id_contrato === ""
      ) {
        mensaje.push("Ups, algo salio mal. ID de contrato no encontrado");
      }

      if (mensaje.length) {
        return this.$msgBoxOk(
          mensaje.map((msj) => this.$createElement("p", msj)),
          {
            title: this.$createElement("h4", "Controlar formulario"),
          },
        );
      }

      await this.estadoAvl();
    },

    async submit() {
      if (this.mostrarCaptcha && !this.isCaptchaValid) {
        return;
      }

      if (this.mostrarCaptcha) {
        this.$bvModal.hide("CaptchaModal");
      }

      try {
        const viaticosFormateados = this.$refs.viaticosForm
          ? this.$refs.viaticosForm.getFormattedViaticos()
          : this.viaticos;

        const resp = await axios.post("/execute", {
          method: "dbo.sp_BajaContrato",
          parameters: [
            {
              name: "id_instalador",
              value: this.instalador ? this.instalador.id_instaladores : null,
            },
            { name: "id_avl_a_sacar", value: this.idAvlASacar },
            { name: "id_cliente", value: this.idCliente },
            {
              name: "combo_irrecuperable",
              value: this.comboIrrecuperable ? 1 : 0,
            },
            { name: "entregado_en_mano", value: this.entregadoEnMano ? 1 : 0 },
            {
              name: "comentario_trazabilidad",
              value: this.comentarioTrazabilidad,
            },
            { name: "costo_AVL", value: Number(this.costoAVL) },
            { name: "taller", value: this.taller ? 1 : 0 },
            { name: "relay", value: this.relay ? 1 : 0 },
            {
              name: "fecha_baja",
              value: moment(this.fechaBaja).format("YYYY-MM-DD HH:mm"),
            },
            { name: "precioXmayor", value: this.precioXmayor ? 1 : 0 },
            {
              name: "devolucion_por_dias_sin_servicio",
              value: this.devolucion_por_dias_sin_servicio ? 1 : 0,
            },
            {
              name: "viaticos_cliente_activo",
              value: viaticosFormateados.viaticosCliente.activo ? 1 : 0,
            },
            {
              name: "viaticos_cliente_combustible_activo",
              value: viaticosFormateados.viaticosCliente.combustible.activo
                ? 1
                : 0,
            },
            {
              name: "viaticos_cliente_combustible_kilometros",
              value: viaticosFormateados.viaticosCliente.combustible.kilometros,
            },
            {
              name: "viaticos_cliente_combustible_monto_calculado",
              value:
                viaticosFormateados.viaticosCliente.combustible.montoCalculado,
            },
            {
              name: "viaticos_cliente_combustible_descripcion",
              value:
                viaticosFormateados.viaticosCliente.combustible.descripcion,
            },
            {
              name: "viaticos_cliente_adicional_activo",
              value: viaticosFormateados.viaticosCliente.viaticoAdicional.activo
                ? 1
                : 0,
            },
            {
              name: "viaticos_cliente_adicional_monto",
              value: viaticosFormateados.viaticosCliente.viaticoAdicional.monto,
            },
            {
              name: "viaticos_cliente_adicional_descripcion",
              value:
                viaticosFormateados.viaticosCliente.viaticoAdicional
                  .descripcion,
            },
            {
              name: "viaticos_instalador_activo",
              value: viaticosFormateados.viaticosInstalador.activo ? 1 : 0,
            },
            {
              name: "viaticos_instalador_combustible_activo",
              value: viaticosFormateados.viaticosInstalador.combustible.activo
                ? 1
                : 0,
            },
            {
              name: "viaticos_instalador_combustible_kilometros",
              value:
                viaticosFormateados.viaticosInstalador.combustible.kilometros,
            },
            {
              name: "viaticos_instalador_combustible_monto_calculado",
              value:
                viaticosFormateados.viaticosInstalador.combustible
                  .montoCalculado,
            },
            {
              name: "viaticos_instalador_combustible_descripcion",
              value:
                viaticosFormateados.viaticosInstalador.combustible.descripcion,
            },
            {
              name: "viaticos_instalador_adicional_activo",
              value: viaticosFormateados.viaticosInstalador.viaticoAdicional
                .activo
                ? 1
                : 0,
            },
            {
              name: "viaticos_instalador_adicional_monto",
              value:
                viaticosFormateados.viaticosInstalador.viaticoAdicional.monto,
            },
            {
              name: "viaticos_instalador_adicional_descripcion",
              value:
                viaticosFormateados.viaticosInstalador.viaticoAdicional
                  .descripcion,
            },
            {
              name: "id_contrato",
              value: this.$route.params.id_contrato,
            },
            {
              name: "id_empresas_propias",
              value:
                get(this.empresaPropia, "id_empresas_propias", null) === 0
                  ? null
                  : get(this.empresaPropia, "id_empresas_propias", null),
            },
            {
              name: "id_empresa",
              value: get(this.empresa, "id_empresa", null),
            },
            {
              name: "subfactura",
              value: get(this.subfactura, "subfactura", null),
            },
          ],
        });

        if (resp.data.ok) {
          try {
            await this.$msgBoxOk("Contrato dado de baja con exito");
            this.$emit("bajaContrato");
            this.$router.push(
              `/admin/clientes/${this.$route.params.id_cliente}/contratos`,
            );
          } catch (modalError) {
            this.$emit("bajaContrato");
            this.$router.push(
              `/admin/clientes/${this.$route.params.id_cliente}/contratos`,
            );
          }
        } else {
          await this.$msgBoxOk(resp.data.message);
        }
      } catch (error) {
        console.error("Error: ", error);
        try {
          await this.$msgBoxOk(
            "Ha ocurrido un error al procesar la baja del contrato",
          );
        } catch (modalError) {
          console.warn("Error: ", modalError);
        }
      }
    },
  },
  computed: {
    nombreCliente() {
      return get(
        this.$store.state.Contratos.ModificarContrato,
        "nombreWeb",
        "",
      );
    },
    Fecha_baja: {
      get() {
        return moment().format("YYYY-MM-DD HH:mm");
      },
    },
    alias: {
      get() {
        return this.$store.state.Contratos.ModificarContrato.dominioAnterior;
      },
    },
    patente: {
      get() {
        return this.$store.state.Contratos.ModificarContrato.patenteAnterior;
      },
    },
    idAvlASacar: {
      get() {
        return this.$store.state.Contratos.ModificarContrato.avl;
      },
    },
    imei: {
      get() {
        return this.$store.state.Contratos.ModificarContrato.imei;
      },
    },
    empresaPropia: {
      get() {
        return this.$store.state.Contratos.ModificarContrato.empresaPropia;
      },
    },
    empresa: {
      get() {
        return this.$store.state.Contratos.ModificarContrato.empresa;
      },
    },
    subfactura: {
      get() {
        return this.$store.state.Contratos.ModificarContrato.subfactura;
      },
    },

    instaladorOk() {
      return !!this.instalador;
    },
    costoAVLOk() {
      return this.comboIrrecuperable
        ? this.costoAVL !== null &&
            this.costoAVL !== "" &&
            !Number.isNaN(Number(this.costoAVL))
        : true;
    },
    isFormOk() {
      return this.instaladorOk && this.costoAVLOk;
    },
    contrato() {
      const idContrato = this.$route.params.id_contrato;
      return idContrato;
    },
    hayEmpresasCliente() {
      return this.empresaPropia || this.empresa || this.subfactura;
    },
  },
  watch: {
    comboIrrecuperable: {
      handler(val) {
        if (val) {
          this.costoAVL = 0;
          this.instalador = null;
          this.entregadoEnMano = false;
          this.taller = false;
          this.relay = false;
          this.precioXmayor = false;
        } else {
          this.entregadoEnMano = true;
        }
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    this.$bvModal.hide("BajaContratoModal");
    this.$bvModal.hide("CaptchaModal");
  },
};
</script>

<style scoped>
.captcha-container {
  padding: 1rem;
}
</style>
